import ArrowForward from '@mui/icons-material/ArrowForward';

import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import CardMedia from '@zenbusiness/zui/CardMedia';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const ProductCard = superstyled({
  name: 'ProductCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    ...BASE_STYLES,
    padding: theme.spacing(0),
    borderRadius: theme.shape.rounded.xl
    // '&:last-child': {
    //   paddingBottom: theme.spacing(3),
    // }
  })
});

export const ProductCardImage = superstyled({
  name: 'ProductCardImage',
  slot: 'Image',
  tag: CardMedia,
  propsAdded: {
    component: 'figure'
  },
  styles: () => ({
    position: 'relative',
    height: '12.5rem',
    width: '100%',
    margin: 0
  })
});

export const Image = superstyled({
  name: 'ProductCard',
  slot: 'Image',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    alignSelf: 'center',
    borderRadiusTopLeft: theme.shape.rounded.xl,
    borderRadiusTopRight: theme.shape.rounded.xl,
    width: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
    position: 'relative'
  })
});

export const ProductCardIcon = superstyled({
  name: 'ProductCardIcon',
  slot: 'Icon',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '4rem',
    height: '4rem',
    objectFit: 'contain',
    position: 'absolute',
    backgroundColor: theme.palette.background.grey.main,
    padding: theme.spacing(1),
    borderRadius: theme.shape.rounded.md,
    top: '92%',
    left: theme.spacing(3),
    transform: 'translateY(-50%)',
    boxShadow: theme.shadows[2]
  })
});

export const ProductCardTitle = superstyled({
  name: 'ProductCardTitle',
  slot: 'Title',
  tag: Text,
  styles: () => ({})
});

export const ProductCardContent = superstyled({
  name: 'ProductCardContent',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(4.5, 3, 3, 3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  })
});

export const ProductCardDescription = superstyled({
  name: 'ProductCardDescription',
  slot: 'Description',
  tag: Text,
  styles: () => ({})
});

export const ProductCardButton = superstyled({
  name: 'ProductCardButton',
  slot: 'Button',
  tag: Button,
  styles: () => ({})
});

export const TextHighlight = superstyled({
  name: 'ProductCard',
  slot: 'TextHighlight',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 600
  })
});

export const ArrowForwardIcon = superstyled({
  name: 'ProductCard',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.secondary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});
